/** Deterministic PRNG (mulberry32) so mock data is identical on every reload and in screenshots. */
export const createRandom = (seed: number) => {
  let state = seed >>> 0;
  const next = () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    int: (min: number, max: number) => Math.floor(next() * (max - min + 1)) + min,
    pick: <T>(items: readonly T[]): T => items[Math.floor(next() * items.length)] as T,
    /** ISO date `days` back from a fixed reference date (keeps data stable over time). */
    pastDate: (maxDaysBack: number, from = REFERENCE_DATE) =>
      new Date(from.getTime() - Math.floor(next() * maxDaysBack * 86_400_000)).toISOString(),
    futureDate: (maxDaysAhead: number, from = REFERENCE_DATE) =>
      new Date(from.getTime() + Math.floor(next() * maxDaysAhead * 86_400_000)).toISOString(),
  };
};

export const REFERENCE_DATE = new Date('2026-09-27T13:31:00Z');

export const companies = [
  'Clark Construction Group, LLC',
  'Capitol Builders Inc.',
  'Anacostia Renovations',
  'Potomac Events Co.',
  'District Restaurant Group',
  'Northeast Housing Partners',
  'Rock Creek Developers',
] as const;

export const streets = [
  '2400 E Capitol St SE',
  '1100 New York Ave NW',
  '800 Hamilton St NW',
  '1500 Taylor St NE',
  '450 Michigan Ave NE',
  '901 Independence Ave SE',
  '330 Benning Rd NE',
  '1250 9th St NW',
] as const;

/** Random point inside central Washington, DC. */
export const dcLocation = (random: ReturnType<typeof createRandom>) => ({
  lat: 38.87 + random.next() * 0.09,
  lng: -77.04 + random.next() * 0.1,
});
